// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {UserScreenLayout} from 'app_components/screens/admin/user'
// @end

// @import events
// @end

// @import utils
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import { I18nUtil } from 'app_utils/i18n'
// @end

// @import services
import PermissionService from 'app_services/secure/permission/permissionService'
import UserService from 'app_services/user/userService'
// @end

// @import types
import { IPagination } from 'app_types/pagination/paginationTypes'
import { INewUser, IUserListItem, IUsersHttpResponse, UserFormInputs } from 'app_types/admin/user/userTypes'
// @end

// @ADD Component types
interface IUserScreenProps {
  role?: string
  show_inputs?: UserFormInputs[]
  editabled_inputs?: UserFormInputs[]
}
interface IUserScreenState {
  status: null | 'loading' | 'error'
  userList: IUserListItem[]
  add: boolean
  edit: boolean
  view: boolean
  editData: null | IUserListItem
  selectedRow: null | string
  pagination: IPagination
  searchFormInputs: any
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class UserScreen extends Component<IUserScreenProps, IUserScreenState> {

  public moduleName: string = 'module:users'
  private permission: PermissionService
  private screenNotifications: ScreenNotificationsUtil
  private userService: UserService
  private i18nUtil: I18nUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IUserScreenProps) {
    super(props)
    this.state = {
      status: 'loading',
      userList: [],
      add: false,
      edit: false,
      view: false,
      editData: null,
      selectedRow: null,
      searchFormInputs: {},
      pagination: {
        page: 1,
        perPage: 10,
        total: 0,
      },
    }

    this.permission = new PermissionService(this.moduleName)
    this.screenNotifications = new ScreenNotificationsUtil()
    this.userService = new UserService()
    this.i18nUtil = new I18nUtil()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    await this.getUserList()
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  onRowClick = async (row: any) => {
    if (this.state.selectedRow === row._id) {
      this.setState({ selectedRow: null })
    } else {
      // this.setState({ status: 'loading' })
      const user: any = this.state.userList.find((user) => user._id === row._id)

      if (!user?.details) {
        await this.getUser(row._id)
      }

      this.setState({
        selectedRow: row._id,
        // status: null,
      })
    }
  }

  showAddUserForm = async (add: boolean) => {
    this.setState({ add })
  }

  showEditUserForm = async (edit: boolean, user?: any) => {
    if (edit && user) {
      await this.getUser(user._id)
      this.setState({ edit: true, editData: user })
    } else {
      this.setState({ edit: false })
    }
  }

  onViewerRow = async (view: boolean, register?: any) => {
    if (view && register) {
      await this.getUser(register._id)
      this.setState({ view: true, editData: register })
    } else {
      this.setState({ view: false })
    }
  }

  onPageChange = async (page: number) => {
    this.getUserList({ page })
  }

  onSearch = async (event: any) => {
    this.setState({searchFormInputs: event ? event : {}}, () => {
      this.getUserList({ page: 1, ...event })
    });
    return false
  }

  showModal = async () => {
    // this.getUserList({ search: '' })
  }

  getUser = async (userId: string) => {
    // this.setState({ status: 'loading' })

    const userIndex = this.state.userList.findIndex((user) => user._id === userId)
    const userList: Array<any> = [...this.state.userList]

    const user: any = await this.userService.getOne(userId)
    if (user) {
      userList[userIndex].details = user
    } else {
      // this.setState({ status: 'error' })
    }
  }

  getUserList = async (_params?: any) => {
    this.setState({ status: 'loading' })
    let params = {
      ...this.state.searchFormInputs ? this.state.searchFormInputs : {},
      ..._params ? _params : {}
    }

    const httpParams: any = {
      pageNumber: params?.page ? params?.page : this.state.pagination.page,
      nPerPage: params?.perPage ? params?.perPage : this.state.pagination.perPage,
    }

    if (params?.search) {
      httpParams.search = params?.search
    }

    if (this.props?.role) {
      httpParams.role_names = this.props?.role
    }

    let userList: IUsersHttpResponse | null = await this.userService.get(httpParams)

    if (userList?.status_code === 'success') {
      this.setState({
        userList: userList?.users,
        pagination: {
          total: userList?.total_register,
          perPage: userList?.nPerPage,
          page: userList?.pageNumber,
        },
        status: null,
      })
    } else {
      this.setState({ status: 'error' })
    }
  }

  addUser = async (userResponse: any) => {
    if (userResponse) {
      this.setState({ add: false })
      this.getUserList()
    }
  }

  updateUser = async (userResponse: INewUser) => {
    if (userResponse) {
      this.setState({ edit: false })
      this.getUserList()
    }
  }

  removeUser = async (userId: string) => {
    let confirm = this.screenNotifications.fire({
      message: `${this.i18nUtil.getTranslate('screens.users.delete.message')}`,
    },
    {
      type: 'warning',
      title: `${this.i18nUtil.getTranslate('screens.users.delete.title')}`,
      confirmButtonText: `${this.i18nUtil.getTranslate('components.screen_notifications.buttons.confirmButtonText')}`,
      cancelButtonText: `${this.i18nUtil.getTranslate('components.screen_notifications.buttons.cancelButtonText')}`,

      showCancelButton: true,
    })

    if (confirm) {
      confirm.then(async (result) => {
        if (result.value) {
          // this.setState({ status: 'loading' })

          const removeUser = await this.userService.remove(userId)

          if (removeUser) {
            this.screenNotifications.fireToast(
              {
                message: `${this.i18nUtil.getTranslate('components.screen_notifications.delete')}`,
              },

              {
                position: 'bottom-right',
              },
            )

            this.getUserList()
          }

          // this.setState({ status: null })
        }
      })
    }
  }

  render() {
    return(
      <UserScreenLayout
        add={this.permission.check('permission:users_create', this.state.add)}
        edit={this.permission.check('permission:users_update', this.state.edit) || this.permission.check('edit_own_profile', this.state.edit)}
        view={this.permission.check('permission:users_viewer', this.state.view)}
        editData={this.state.editData}
        onRowClick={this.onRowClick}
        onViewerRow={this.permission.check('permission:users_viewer', this.onViewerRow)}
        selectedRow={this.state.selectedRow}
        showAddUserForm={this.permission.check('permission:users_create', this.showAddUserForm)}
        showEditUserForm={this.permission.check('permission:users_update', this.showEditUserForm)}
        pagination={this.state.pagination}
        onPageChange={this.onPageChange}
        userList={this.permission.check('permission:users_list', this.state.userList)}
        addUser={this.permission.check('permission:users_create', this.addUser)}
        updateUser={this.permission.check('permission:users_update', this.updateUser) || this.permission.check('edit_own_profile', this.updateUser)}
        removeUser={this.permission.check('permission:users_delete', this.removeUser)}
        onSearch={this.permission.check('permission:users_list', this.onSearch)}
        role={this.props.role}
        searchFormInputs={this.state.searchFormInputs}
        status={this.state.status}
        showModal={this.showModal}
        show_inputs={this.props.show_inputs || undefined}
        editabled_inputs={this.props.editabled_inputs || undefined}
      />
    )
  }
}

export default connect(mapStatesToProps)(UserScreen)
